import type { ExploreFilter, Product, ProductGroup } from '@/packages/explore/types'

export const EXPLORE_FILTERS: ExploreFilter[] = [
  { id: 'tools', label: { hu: 'Eszközök', en: 'Tools' } },
  {
    id: 'student-services',
    label: { hu: 'Tanulmányok és ügyintézés', en: 'Studies and Administration' },
  },
  { id: 'student-life', label: { hu: 'Hallgatói élet', en: 'Student Life' } },
  { id: 'community', label: { hu: 'Közösség', en: 'Community' } },
]

export const HIGHLIGHTED_PRODUCTS: Product[] = [
  {
    id: 'do-it-online',
    label: { hu: 'Intézd Online', en: 'Do it Online' },
    icon: 'globe',
    href: {
      hu: 'https://myhub.uni-corvinus.hu',
      en: 'https://myhub.uni-corvinus.hu',
    },
  },
  {
    id: 'schedule',
    label: { hu: 'Tanév rendje', en: 'Schedule' },
    icon: 'schedule',
    to: '/studies/academic-calendar',
  },
  { id: 'news', label: { hu: 'Hírek', en: 'News' }, icon: 'newspaper', to: '/news' },
  { id: 'events', label: { hu: 'Események', en: 'Events' }, icon: 'calendar', to: '/events' },
]

export const PRODUCT_GROUPS: ProductGroup[] = [
  {
    id: 'tools',
    title: { hu: 'Eszközök', en: 'Tools' },
    products: [
      {
        id: 'neptun',
        label: { hu: 'Neptun', en: 'Neptun' },
        icon: 'neptun',
        href: {
          hu: 'https://neptun3r.web.uni-corvinus.hu/hallgatoi/login',
          en: 'https://neptun3r.web.uni-corvinus.hu/hallgatoi/login',
        },
      },
      {
        id: 'careeros',
        label: { hu: 'CareerOS', en: 'CareerOS' },
        icon: 'careeros',
        href: {
          hu: 'https://app.thecareeros.com/',
          en: 'https://app.thecareeros.com/',
        },
      },
      {
        id: 'moodle',
        label: { hu: 'Moodle', en: 'Moodle' },
        icon: 'moodle',
        href: {
          hu: 'https://moodle.uni-corvinus.hu/',
          en: 'https://moodle.uni-corvinus.hu/',
        },
      },
      {
        id: 'myview',
        label: { hu: 'MyView', en: 'MyView' },
        icon: 'edit',
        href: {
          hu: 'https://neptun3r.web.uni-corvinus.hu/hallgatoi/administrations/questionnaire',
          en: 'https://neptun3r.web.uni-corvinus.hu/hallgatoi/administrations/questionnaire',
        },
      },
    ],
  },
  {
    id: 'student-services',
    title: { hu: 'Tanulmányok és ügyintézés', en: 'Studies and Administration' },
    products: [
      {
        id: 'scholarships',
        label: { hu: 'Ösztöndíjak', en: 'Scholarships' },
        icon: 'banknote',
        to: '/discover?category=scholarships',
      },
      {
        id: 'programmes-curriculum',
        label: { hu: 'Képzések és tanterv', en: 'Programmes and Curriculum' },
        icon: 'programes',
        href: {
          hu: 'https://www.uni-corvinus.hu/ona/hallgatoi-tanulmanyi-ugyek/kepzesi-programok/',
          en: 'https://www.uni-corvinus.hu/ind/programs-curriculum-degree/?lang=en',
        },
      },
      {
        id: 'it-services',
        label: { hu: 'IT szolgáltatások', en: 'IT Services' },
        icon: 'it',
        href: {
          hu: 'https://www.uni-corvinus.hu/fooldal/elet-a-corvinuson/informatikai-szolgaltatasok/',
          en: 'https://www.uni-corvinus.hu/main-page/life-at-corvinus/it-services/?lang=en',
        },
      },

      {
        id: 'feedback',
        label: { hu: 'Visszajelzés', en: 'Feedback' },
        icon: 'feedback',
        href: {
          hu: 'https://www.uni-corvinus.hu/fooldal/elet-a-corvinuson/hallgatoi-elegedettsegmeres/',
          en: 'https://www.uni-corvinus.hu/main-page/life-at-corvinus/students-satisfaction-evaluation/?lang=en',
        },
      },
      {
        id: 'for-freshmen',
        label: { hu: 'Gólyáknak', en: 'For Freshmen' },
        icon: 'fresher',
        href: {
          hu: 'https://www.uni-corvinus.hu/post/landing-page/welcome-to-corvinus/',
          en: 'https://www.uni-corvinus.hu/post/landing-page/welcome-to-corvinus/?lang=en',
        },
      },
      {
        id: 'ss-do-it-online',
        label: { hu: 'Intézd Online', en: 'Do it Online' },
        icon: 'globe',
        href: {
          hu: 'https://myhub.uni-corvinus.hu',
          en: 'https://myhub.uni-corvinus.hu',
        },
      },
      {
        id: 'myview',
        label: { hu: 'MyView', en: 'MyView' },
        icon: 'edit',
        href: {
          hu: 'https://www.uni-corvinus.hu/fooldal/elet-a-corvinuson/hallgatoi-elegedettsegmeres/#myview',
          en: 'https://www.uni-corvinus.hu/main-page/life-at-corvinus/students-satisfaction-evaluation/?lang=en#myview',
        },
      },
      {
        id: 'schedule',
        label: { hu: 'Tanév rendje', en: 'Schedule' },
        icon: 'schedule',
        to: '/studies/academic-calendar',
      },
    ],
  },
  {
    id: 'student-life',
    title: { hu: 'Hallgatói élet', en: 'Student Life' },
    products: [
      {
        id: 'mobilities',
        label: { hu: 'Mobilitás', en: 'Mobilities' },
        icon: 'mobilites',
        href: {
          hu: 'https://www.uni-corvinus.hu/post/landing-page/nemzetkozi-lehetosegek/',
          en: 'https://www.uni-corvinus.hu/post/landing-page/nemzetkozi-lehetosegek/?lang=en',
        },
      },
      {
        id: 'wellbeing',
        label: { hu: 'Jólét és akadálymentesség', en: 'Wellbeing and Accessibility' },
        icon: 'well-being',
        href: {
          hu: 'https://www.uni-corvinus.hu/post/landing-page/hallgatoi-wellbeing-es-kozosseg-kozpont/',
          en: 'https://www.uni-corvinus.hu/post/landing-page/hallgatoi-wellbeing-es-kozosseg-kozpont/?lang=en',
        },
      },
      {
        id: 'sport',
        label: { hu: 'Sport', en: 'Sport' },
        icon: 'sport',
        href: {
          hu: 'https://www.uni-corvinus.hu/post/landing-page/Sport/',
          en: 'https://www.uni-corvinus.hu/post/landing-page/Sport/?lang=en',
        },
      },
      {
        id: 'career-support',
        label: { hu: 'Karrier', en: 'Career' },
        icon: 'briefcase',
        href: {
          hu: 'https://www.uni-corvinus.hu/ona/karrier-2/hallgatoknak/karriertamogatas/',
          en: 'https://www.uni-corvinus.hu/ind/career-2/for-students/career-support/?lang=en',
        },
      },
      {
        id: 'dormitory',
        label: { hu: 'Kollégium', en: 'Dormitory' },
        icon: 'dormitory',
        href: {
          hu: 'https://www.uni-corvinus.hu/post/landing-page/szallaslehetoseg-es-kollegiumok/',
          en: 'https://www.uni-corvinus.hu/post/landing-page/szallaslehetoseg-es-kollegiumok/?lang=en',
        },
      },
      {
        id: 'ss-navigator',
        label: { hu: 'Navigátor', en: 'Navigator' },
        icon: 'compass',
        href: {
          hu: 'https://www.uni-corvinus.hu/post/landing-page/navigator/',
          en: 'https://www.uni-corvinus.hu/post/landing-page/navigator/?lang=en',
        },
      },
      {
        id: 'library',
        label: { hu: 'Könyvtár', en: 'Library' },
        icon: 'library',
        href: {
          hu: 'https://www.uni-corvinus.hu/fooldal/kutatas/egyetemi-konyvtar/',
          en: 'https://www.uni-corvinus.hu/main-page/research/university-library/?lang=en',
        },
      },
      {
        id: 'health',
        label: { hu: 'Egészség', en: 'Health' },
        icon: 'health',
        href: {
          hu: 'https://www.uni-corvinus.hu/post/landing-page/egeszseg/',
          en: 'https://www.uni-corvinus.hu/post/landing-page/health/?lang=en',
        },
      },
      { id: 'sl-news', label: { hu: 'Hírek', en: 'News' }, icon: 'newspaper', to: '/news' },
      {
        id: 'sl-events',
        label: { hu: 'Események', en: 'Events' },
        icon: 'calendar',
        to: '/events',
      },
    ],
  },
  {
    id: 'community',
    title: { hu: 'Közösség', en: 'Community' },
    products: [
      {
        id: 'campuses',
        label: { hu: 'Kampuszok', en: 'Campuses' },
        icon: 'campus',
        href: {
          hu: 'https://www.uni-corvinus.hu/fooldal/egyetemunkrol/az-egyetem-campusai/',
          en: 'https://www.uni-corvinus.hu/main-page/about-the-university/campuses/?lang=en',
        },
      },
      {
        id: 'competitions',
        label: { hu: 'Versenyek', en: 'Competitions' },
        icon: 'competitions',
        href: {
          hu: 'https://www.uni-corvinus.hu/post/landing-page/versenyek/',
          en: 'https://www.uni-corvinus.hu/post/landing-page/competitions/?lang=en',
        },
      },
      {
        id: 'students-union',
        label: { hu: 'Hallgatói önkormányzat', en: 'Students Union' },
        icon: 'student',
        href: {
          hu: 'https://www.uni-corvinus.hu/fooldal/elet-a-corvinuson/hallgatoi-onkormanyzat/',
          en: 'https://www.uni-corvinus.hu/main-page/life-at-corvinus/student-association/?lang=en',
        },
      },
      {
        id: 'student-associations',
        label: { hu: 'Hallgatói szervezetek', en: 'Student Associations' },
        icon: 'student-associations',
        href: {
          hu: 'https://www.uni-corvinus.hu/post/landing-page/diakszervezetek-szakkollegiumok/',
          en: 'https://www.uni-corvinus.hu/post/landing-page/diakszervezetek-szakkollegiumok/?lang=en',
        },
      },
      {
        id: 'advanced-college',
        label: { hu: 'Szakkollégiumok', en: 'Colleges for Advanced Students' },
        icon: 'colleges',
        href: {
          hu: 'https://www.uni-corvinus.hu/post/landing-page/diakszervezetek-szakkollegiumok/',
          en: 'https://www.uni-corvinus.hu/post/landing-page/diakszervezetek-szakkollegiumok/?lang=en',
        },
      },
      {
        id: 'science',
        label: { hu: 'Corvinus Science Shop', en: 'Corvinus Science Shop' },
        icon: 'science',
        href: {
          hu: 'https://www.uni-corvinus.hu/main-page/research/corvinus-science-shop/?lang=en',
          en: 'https://www.uni-corvinus.hu/main-page/research/corvinus-science-shop/?lang=en',
        },
      },
      {
        id: 'mentor-programmes',
        label: { hu: 'Mentorprogramok', en: 'Mentor Programmes' },
        icon: 'mentor',
        href: {
          hu: 'https://www.uni-corvinus.hu/post/landing-page/mentor-programok/',
          en: 'https://www.uni-corvinus.hu/post/landing-page/mentor-programmes/?lang=en',
        },
      },
    ],
  },

  // {
  //   id: 'misc',
  //   title: 'Misc',
  //   products: [
  //     {
  //       id: 'for-freshmen',
  //       label: 'For Freshmen',
  //       icon: 'user',
  //       href: {
  //         hu: 'https://www.uni-corvinus.hu/post/landing-page/welcome-to-corvinus/',
  //         en: 'https://www.uni-corvinus.hu/post/landing-page/welcome-to-corvinus/?lang=en',
  //       },
  //     },
  //     {
  //       id: 'student-organizations',
  //       label: 'Student Organizations',
  //       icon: 'user',
  //       href: {
  //         hu: 'https://www.uni-corvinus.hu/post/landing-page/diakszervezetek-szakkollegiumok/',
  //         en: 'https://www.uni-corvinus.hu/post/landing-page/diakszervezetek-szakkollegiumok/?lang=en',
  //       },
  //     },
  //     {
  //       id: 'academic-calendar',
  //       label: 'Academic Calendar',
  //       icon: 'calendar',
  //       to: '/studies/academic-calendar',
  //     },
  //     {
  //       id: 'student-services-admin',
  //       label: 'Student Services',
  //       icon: 'student',
  //       href: {
  //         hu: 'https://www.uni-corvinus.hu/post/landing-page/hallgatoi-tanulmanyi-ugyek/',
  //         en: 'https://www.uni-corvinus.hu/post/landing-page/international-and-administrative-student-services/?lang=en',
  //       },
  //     },
  //     {
  //       id: 'finances',
  //       label: 'Finances',
  //       icon: 'banknote',
  //       href: {
  //         hu: 'https://www.uni-corvinus.hu/ona/hallgatoi-tanulmanyi-ugyek/penzugy/',
  //         en: 'https://www.uni-corvinus.hu/ind/international-and-administrative-student-services/finance-and-scholarships/?lang=en',
  //       },
  //     },
  //     {
  //       id: 'satisfaction',
  //       label: 'Satisfaction',
  //       href: {
  //         hu: 'https://www.uni-corvinus.hu/fooldal/elet-a-corvinuson/hallgatoi-elegedettsegmeres/',
  //         en: 'https://www.uni-corvinus.hu/main-page/life-at-corvinus/students-satisfaction-evaluation/?lang=en',
  //       },
  //     },
  //     {
  //       id: 'regulations',
  //       label: 'Regulations',
  //       href: {
  //         hu: 'https://www.uni-corvinus.hu/fooldal/egyetemunkrol/szabalyzatok-utasitasok/',
  //         en: 'https://www.uni-corvinus.hu/main-page/about-the-university/regulations-provisions/?lang=en',
  //       },
  //     },
  //     {
  //       id: 'it-systems',
  //       label: 'IT Systems',
  //       href: {
  //         hu: 'https://www.uni-corvinus.hu/fooldal/elet-a-corvinuson/informatikai-szolgaltatasok/',
  //         en: 'https://www.uni-corvinus.hu/main-page/life-at-corvinus/it-services/?lang=en',
  //       },
  //     },
  //     {
  //       id: 'digital-services',
  //       label: 'Digital Services',
  //       icon: 'paperclip',
  //       href: {
  //         hu: 'https://www.uni-corvinus.hu/post/landing-page/digitalis-fejlesztesek/',
  //         en: 'https://www.uni-corvinus.hu/post/landing-page/digitalis-fejlesztesek/?lang=en',
  //       },
  //     },
  //     {
  //       id: 'contacts',
  //       label: 'Contacts',
  //       icon: 'user',
  //       href: {
  //         hu: 'https://www.uni-corvinus.hu/main-page/about-the-university/contact/',
  //         en: 'https://www.uni-corvinus.hu/main-page/about-the-university/contact/?lang=en',
  //       },
  //     },
  //     { id: 'discounts', label: 'Discounts', icon: 'discount', to: '/services/discounts' },
  //     { id: 'media-studio', label: 'Media Studio', icon: 'camera', to: '/services/media' },
  //     { id: 'makerspace', label: 'Makerspace', icon: 'products', to: '/services/makerspace' },
  //     { id: 'civil-ties', label: 'Civil ties', icon: 'user', to: '/services/civil-ties' },
  //   ]
  // }
]
